module.exports = __webpack_public_path__ + "static/media/logo.e1c56ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 924
// module chunks = 0